import React from 'react';

type TooltipProps = {
  children?: React.ReactNode;
  content: React.ReactNode;
  position?: 'right' | 'top' | 'bottom';
};

const Tooltip: React.FC<TooltipProps> = ({ children, content, position = 'right' }) => {
  const posClass =
    position === 'right'
      ? 'left-full top-1/2 -translate-y-1/2 ml-2'
      : position === 'top'
      ? 'bottom-full left-1/2 -translate-x-1/2 mb-2'
      : 'left-1/2 -translate-x-1/2 mt-2';

  // Parent element should have `group` to allow group-hover/group-focus to show tooltip.
  return (
    <span className="relative inline-flex">
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute z-50 ${posClass} whitespace-nowrap bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 transform transition-all duration-150 scale-95 hover:opacity-100 hover:scale-100 focus:opacity-100`}
        tabIndex={-1}
      >
        {content}
      </span>
    </span>
  );
};

export default Tooltip;

